import React from "react";
import { Box } from "./Box";
import { MainText } from "./MainText";
import { PressableOpacity } from "./PressableOpacity";
import MessagesIcon from "../Icons/MessagesIcon";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";

type Nullable<T> = T | undefined;

interface Props {
  onPress?: Nullable<() => void>;
  notificationsNumber?: number;
  style?: {};
  iconColor?: string;
  iconWidth?: number;
  iconHeight?: number;
  testID?: string;
}

const MessageIconButton = ({
  onPress = () => null,
  notificationsNumber = 0,
  style = {},
  iconColor = theme.colors["neutral.900"],
  iconWidth = normalize(22),
  iconHeight = normalize(20),
  testID = "",
}: Props) => {
  return (
    <Box style={style} position="relative" zIndex={100}>
      <PressableOpacity
        testID={testID}
        hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
        onPress={onPress}
      >
        <MessagesIcon width={iconWidth} height={iconHeight} color={iconColor} />
        {notificationsNumber > 0 && (
          <Box
            height={20}
            width={20}
            borderRadius={10}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            backgroundColor="system.red.900"
            borderWidth={2}
            borderColor="neutral.white"
            position="absolute"
            top={-10}
            right={-10}
          >
            <MainText variant="l2-medium" color="neutral.white">
              {notificationsNumber}
            </MainText>
          </Box>
        )}
      </PressableOpacity>
    </Box>
  );
};

export default MessageIconButton;
